// Bridges study-plan tasks with the exam/practice/flashcard session they launched,
// so the corresponding finish flow can call complete_study_plan_task automatically.
const PREFIX = "enarm_study_plan_task";

function buildKey(kind, id) {
  return `${PREFIX}_${kind}_${id}`;
}

export function linkStudyPlanTask(kind, id, taskId) {
  if (!kind || !id || !taskId) return;

  try {
    localStorage.setItem(buildKey(kind, id), String(taskId));
  } catch (error) {
    console.warn("No se pudo guardar la referencia de la tarea del plan de estudio.", error);
  }
}

export function consumeStudyPlanTaskLink(kind, id) {
  if (!kind || !id) return null;

  try {
    const key = buildKey(kind, id);
    const taskId = localStorage.getItem(key);

    if (taskId) {
      localStorage.removeItem(key);
    }

    return taskId;
  } catch (error) {
    console.warn("No se pudo leer la referencia de la tarea del plan de estudio.", error);
    return null;
  }
}
